<template>
    <div class="container">
        <b-modal 
            :model-value="modalEditar"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >            
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">
                        {{ labels.formInfoTitle }}
                    </div>
                    <div class="password-policy-item">
                        {{ labels.formInfoSubtitle }}
                    </div>
                </div>
                <b-col md="4" lg="12" class="p-0 mx-auto">
                    <b-form-group>
                        <label>{{ labels.codigo }}</label>
                        <p>{{ form.tipo_contrato }}</p>
                        <label>{{ labels.descripcion }}</label>
                        <b-form-input
                            v-model="form.descripcion"
                            type="text"
                            class="reset-input"
                        ></b-form-input>
                    </b-form-group>
                    <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                        <b-button
                            class="reset-btn-delete me-auto"
                            @click="eliminaRegistro()"
                        >
                            {{ labels.delete }}
                        </b-button>
                        <b-button
                            class="reset-btn-secondary"
                            @click="cierraModal()"
                        >
                            {{ labels.close }}
                        </b-button>
                        <b-button
                            class="reset-btn-primary"
                            @click="guardarTipoContrato()"
                        >
                            {{ labels.save }}
                        </b-button>
                    </div>
                </b-col>
            </div>
        </b-modal>
        <InacticaItem :InactivaItem="deleteTipoContrato" @confirmDelete="confirmInactivate" @cierraModal="cierraModalDelet"/>
    </div>
</template>

<script>
import TipoContrato from '../../../services/TipoContrato' 
import InacticaItem from '../../utils/InacticaItem.vue' 
export default {
    name:'Editar',
    components: {
        InacticaItem
    },
    props: {
        modalEditar: {
            type: Boolean,
            required: true
        },
        infoEdit: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            form: {
                id: null,
                tipo_contrato: "",
                descripcion: ""
            },
            deleteTipoContrato: false,
            idTipoContrato: null
        };
    },
    watch: {
        infoEdit: {
            immediate: true,
            deep: true,
            handler(value) {
                if (value) {
                    this.form = { ...value };
                }
            }
        }
    },
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: "Editar tipo contrato",
                    codigo : "Código",
                    descripcion : "Descripción",
                    save : "Guardar",
                    close : "Cerrar",
                    delete : 'Eliminar',
                    formInfoTitle: "Datos del tipo de contrato",
                    formInfoSubtitle: "Actualiza la información del tipo de contrato y guarda los cambios."
                }
            }else{
                return {
                    title: "Edit contract type",
                    codigo : "Code",
                    descripcion : "Description",
                    save : "Save",
                    close : "Close",
                    delete : 'Delete',
                    formInfoTitle: "Contract type details",
                    formInfoSubtitle: "Update the contract type information and save the changes."
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 
        },
        guardarTipoContrato(){

            if (!this.form.descripcion.trim()) {
                this.$toast.error("Campo pendiente por diligenciar");
                return;
            }

            const info = {
                idTipoContrato: this.form.id,
                descripcion: this.form.descripcion,
                idUser: this.$store.state.userId
            };

            TipoContrato.updateTipoContratoById(info)
            .then((res) => {

                if (res.status == 200) {

                    this.$toast.success(res.data.message);

                    this.$emit("actualizado");
                    this.cierraModal();

                } else if (res.status == 204) {

                    this.$toast.error("Tipo tercero ya existe.");

                }

            })
            .catch(console.error);
        },
        cierraModalDelet(){
            this.deleteTipoContrato = false 
        },
        eliminaRegistro(){
            this.idTipoContrato = this.form.id 
            this.deleteTipoContrato = true 
        },
        confirmInactivate(){
            // console.log(this.idTipoContrato); 
            TipoContrato.deleteTipoContrato(this.idTipoContrato) 
            .then((res) => { 
                if(res.status == 200){ 
                    this.$toast.success(res.data.message) 
                    
                    this.$emit("eliminado");
                    this.cierraModal();
                    this.cierraModalDelet();
                }
            })
            .catch((error) => error) 
        }
    }
}
</script>

<style>

</style>
